import useBackend from '@/hooks/useBackend'

const types = {
  FIXED: ['FIXED_LINE_OR_MOBILE', 'FIXED_LINE', 'UAN'],
  MOBILE: ['MOBILE', 'FIXED_LINE_OR_MOBILE'],
}

import config from '@/config'

const { setup, doGet } = useBackend()
setup('/validations', config.microserviceBaseUrl)

export default function usePhoneValidation() {
  async function isPhoneNumberValid(phoneNumber) {
    const response = await doGet('/phone-number/phone-info', { phoneNumber })
    return response.data
  }

  async function validatePhoneNumber(value, type = false) {
    if (!value) return true

    const response = await isPhoneNumberValid(value)

    const data = response?.data
    const valid = data?.valid
    const correctType = !type || types[type].includes(data?.type)

    if (valid && correctType) {
      return true
    } else if (valid && !correctType) {
      return false
    } else {
      return false
    }
  }

  return {
    validatePhoneNumber,
  }
}
